import React from 'react';
import { Items } from './items';
import { MobileMode } from './mobile-mode/mobile-mode';
/**
 * @typedef {object} CategoryListProps
 * @property {boolean} props.isMobile - Whether to show the mobile version.
 * @property {CategoryItemsPropsT[]} props.items - The list of items to display.
 * @property {(item: T) => void} [props.onItemClick] - Function that handles the click event.
 * @property {(item: T) => boolean} [props.checkSelection] - Function that checks if an item is selected.
 * @property {boolean} [props.disabled] - Whether the component is disabled.
 * @returns {ReactNode} CategoryList component
 *
 * Represents a category item.
 *
 * @typedef {Object} CategoryItemT
 * @property {string | number} id - The unique identifier for the category item.
 * @property {string} title - The title of the category item.
 * @property {number | ReactNode} [count] - The count or a React node to display.
 * @property {CategoryItemT[]} [children] - The child category items.
 * @property {ReactNode} [iconLeft] - The icon to display on the left.
 * @property {boolean} [disabled] - Whether the category item is disabled.
 * @property {boolean} [clickable] - Whether the category item is clickable.
 * @property {boolean} [divider] - Whether the category item has a divider.
 * @property {Object.<string, unknown>} [key] - Additional properties.
 */
export function CategoryList({ isMobile, ...props }) {
    const Component = isMobile ? MobileMode : Items;
    return (React.createElement(Component, { ...props, onItemClick: props.onItemClick, checkSelection: props.checkSelection }));
}
